import React from 'react'
import './logincard.scss'
import Button from '../Button/Button';

import googleIconImg from '../../assets/images/auth/google.png'
import logoWithName from '../../assets/images/logo/VerticalLogoName.png';

function LoginCard() {

    const handleLogin = async () => {
        try {
            const customData = JSON.stringify({
                userRole: "Partner",
                redirect_url: window.location.origin
            });
    
            const redirectUrl = `${process.env.REACT_APP_GOOGLE_VERIFICATION}/v1/auth/google?state=${encodeURIComponent(customData)}`;
            window.location.href = redirectUrl;
        } catch (error) {
            console.log("Error", error);
        }
    };
    

    return (
        <div className='logincard-container'>
            {/* <div className="logo-container">
                <img src={logoWithName} alt="AerialBorne Logo" />
            </div> */}

            <h2 className='card-main-heading'>Welcome</h2>

            <h3 className='new-user-text'>
                Please login with your google account.
            </h3>


            <h5 className='card-main-heading2'>Let's get started</h5>
            <div className='card-login-options'>
           
                <div className='google-loginbtn-container'>
                    <Button
                        label={'Login with Google'}
                        handleClick={handleLogin}
                        
                        fullWidth={true}
                        icon={<img src={googleIconImg} alt='google' style={{ height: '1.5rem', width: '1.5rem' }} />}
                        customStyle={{ padding: '0.65rem 2rem', fontSize: '1rem', fontWeight: '500' }}
                    />
                </div>

                <p className='or-divider'>OR</p>

                <div className='customer-loginbtn-container'>
                    <a href="https://aerialborne.com/" target="_blank" rel="noreferrer">Login as Customer</a>
                </div>
            </div>

            <div className='login-conditions'>
                <p>By continuing you agree to our</p>
                <p>
                    <a href="https://aerialborne.com/refunds" target="_blank" rel="noreferrer"><span>Terms & Condition</span></a> and
                    <a href="https://aerialborne.com/privacy" target="_blank" rel="noreferrer"><span> Privacy Policy</span></a>
                </p>
            </div>
        </div>
    );
}

export default LoginCard;